import { OpenAccountFormStep } from "@/feature/OpenAccount/mixins/interface";

export enum OpenAccountClientType {
	ACTIVE = 'ACTIVE',
	POTENTIAL = 'POTENTIAL',
	NOT_EXIST = 'NOT_EXIST',
}

export enum OpenAccountInvoiceType {
	OPEN = 'OPEN',
	DECLINED_BY_BANK = 'DECLINED_BY_BANK',
	DECLINED_BY_CUSTOMER = 'DECLINED_BY_CUSTOMER',
	ACCOUNT_OPENED = 'ACCOUNT_OPENED',
}

export enum OpenAccountType {
	PRIMARY_ACCOUNT = 'PRIMARY_ACCOUNT',
	SECONDARY_ACCOUNT = 'SECONDARY_ACCOUNT',
}

export interface OpenAccountInvoice {
	applicationId?: string
	applicationNumber?: string
	applicationDateTime?: string
	inn?: string
	pinfl?: string
	legalEntityName?: string
	phoneNumber?: string
	mfo?: string
	accountType?: OpenAccountType
	applicationStatus?: OpenAccountInvoiceType
	appointmentDateTime?: string
	appointmentAddress?: string
	tariffId?: string
	underwriterPhoneNumber?: string
	underwriterName?: string
	countEmployeesNeedsAccessRb?: number
}

export interface OpenAccountDataToSendCode {
	phoneNumber: string
	repeat: boolean
}

export interface OpenAccountDataToVerifyCode {
	phoneNumber: string
	smsCode: string
}

export interface OpenAccountDataToGetClientInfo {
	inn?: string
	pinfl?: string
	phoneNumber: string
	nonClientName: string
}

export interface OpenAccountDataToGetApplication {
	applicationId: string
}

export interface OpenAccountDataToGetInvoiceList extends
	Omit<OpenAccountDataToGetClientInfo, 'nonClientName'> {}

export interface OpenAccountLegalEntity {
	legalEntityState?: OpenAccountClientType
	isMainAccount?: boolean
	legalEntityName?: string
	crmId?: string
	mfo?: string
	nciId?: string
	registrationDateStart?: string
	registrationDateEnd?: string
	registrationAddress?: string
	pinfl?: string
	inn?: string
}

export interface OpenAccountState {
	legalEntityLoading: boolean
	invoice: OpenAccountInvoice | null
	invoiceList: OpenAccountInvoice[]
	step: OpenAccountFormStep
	legalEntityLoadingHint: string
	phoneNumber: string
	requestData: OpenAccountRequestData | null
	legalEntity: OpenAccountLegalEntity | null
}

export type OpenAccountRequestData = OpenAccountDataToSendCode
	& OpenAccountDataToVerifyCode
	& OpenAccountDataToGetClientInfo
	& OpenAccountDataToGetInvoiceList